@use "styles" as *;
@use "sass:map";

$block: me-loading-spinner;

.#{$block} {
  display: block;
  position: relative;
  width: 16px;
  height: 16px;
  transition: $transition-timing;

  &--padding {
    width: 32px;
    height: 32px;
  }

  &__icon {
    position: absolute;

    .#{$block}--padding & {
      top: 8px;
      left: 8px;
    }

    &::before {
      display: block;
      transition: $transition-timing;
    }
  }

  &:not(&--loading) {
    height: 0;
    transform-origin: top center;
    transform: translateY(-8px);
    opacity: 0;

    .#{$block}--padding & {
      transform: translateY(-16px);
    }

    .#{$block}__icon::before {
      transform: scale(0);
    }
  }

    @each $theme, $theme-options in $loading-spinner-themes {
      &--#{$theme} {
        color: map.get($theme-options, color);
      }
    }
}
